'use client';

import { Drawer } from '../../../../common/components/Drawer/Drawer';
import {
  DrawerComponent,
  useDrawerMetadata,
  useModalDrawerContext,
} from '../../../../common/components/ModalDrawerContext/ModalDrawerContext';
import { WithdrawalConfirmationModal } from '../WithdrawalConfirmation/WithdrawalConfirmationModal';
import { WithdrawalSummaryDrawer } from '../WithdrawalSummary/WithdrawalSummaryDrawer';
import { WithdrawalMfaContent } from './WithdrawalMfaContent';

interface WithdrawalMfaDrawerProps {
  amount: string;
  payoutAccountId: string;
  recipientName: string;
  poweredByText?: string;
  tradeId?: string;
}

const WithdrawalMfaDrawerContent: DrawerComponent<WithdrawalMfaDrawerProps> = ({
  amount,
  payoutAccountId,
  recipientName,
  poweredByText,
  tradeId,
}) => {
  const { closeThisDrawer } = useDrawerMetadata();

  const { openDrawer, showModal } = useModalDrawerContext();

  const handleBack = () => {
    closeThisDrawer();

    openDrawer(WithdrawalSummaryDrawer, { amount, poweredByText });
  };

  const handleSuccess = ({
    amount: confirmedAmount,
    recipientName: confirmedRecipientName,
  }: {
    amount: string;
    recipientName: string;
  }) => {
    closeThisDrawer();

    showModal(WithdrawalConfirmationModal, {
      amount: confirmedAmount,
      recipientName: confirmedRecipientName,
      poweredByText,
    });
  };

  return (
    <Drawer hideDefaultHeader>
      <WithdrawalMfaContent
        amount={amount}
        payoutAccountId={payoutAccountId}
        recipientName={recipientName}
        onBack={handleBack}
        onSuccess={handleSuccess}
        tradeId={tradeId}
      />
    </Drawer>
  );
};

export { WithdrawalMfaDrawerContent as WithdrawalMfaDrawer };

export type { WithdrawalMfaDrawerProps };
